import commonEnvironment from 'config/nl/common-environment';
import paypal from 'config/paypal';
import { ShopEnvironment } from 'config/types';

export default {
  ...commonEnvironment,
  apiEndpoint: 'https://api-staging.petsdeli.nl',
  backInStockUrl: 'https://petsdeli-staging.myshopify.com', // TODO: NL Shopify store?
  contentfulEnv: 'staging',
  foodaidEndpoint: 'https://api.petsdeli.de/fube-staging-2023-04',
  ninetailedEnv: 'development',
  oosEndpoint: 'https://api-staging.oos.petsdeli.de',
  paypalClientId: paypal.staging,
  pdexEndpoint: 'https://qa.851725625427.petsdeli.nl',
  shopifyUrl: 'https://petsdeli-staging.myshopify.com', // TODO: NL Shopify store?
  midaKey: 'nvmGW7eJdkWL9dw81xXQKA', // TODO: NL Mida key, or drop it? (CH has none)
  gtmScriptUrl:
    'https://metrics.petsdeli.nl/gtm.js?id=GTM-NK69QT6&gtm_auth=mVziPUTr8RQqgHd0gjcs7Q&gtm_preview=env-334&gtm_cookies_win=x',
  gtmNoScriptUrl:
    'https://metrics.petsdeli.nl/gtm.html?id=GTM-NK69QT6&gtm_auth=mVziPUTr8RQqgHd0gjcs7Q&gtm_preview=env-334&gtm_cookies_win=x',
} satisfies ShopEnvironment;
